import { promisify } from "util"
import { readdir } from "fs"

const readdirPromisified = promisify(readdir)

export const folderRead = async (folder) => {
  const ressources = await readdirPromisified(folder)
  return ressources
}
